import { createScreenView, SCREEN_VIEWS } from '@/global/composables/table/useScreenView'

/**
 * How the work orders overview splits the screen with the map.
 *
 * Opens on the split, the way the tasks and requests listings do: marking an order is
 * there to be looked at on the map, so the map is what the listing opens with. The marked
 * rows are kept across a switch, so orders are marked beside the listing and their routes
 * then looked at on the whole screen.
 */
export const workOrdersScreenView = createScreenView({
  initialView: SCREEN_VIEWS.split
})
